module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-7-57c7527167a52d70e57b62296c8e4bff.svg";